import { useState } from "react";
import { ExportDataButton } from "common/components/ExportDataButton";
import ExportCommissionApprovalsModal from "./exportCommissionApprovalsModal";

export const ExportCommissionApprovalsButton = ({ recruiterIds, clientIds = [] }) => {
  const [open, setOpen] = useState(false);

  const hideModal = () => {
    setOpen(false);
  };

  return (
    <>
      <ExportDataButton onClick={() => setOpen(true)} />
      {open && (
        <ExportCommissionApprovalsModal
          open={open}
          recruiterIds={recruiterIds}
          clientIds={clientIds}
          onSuccess={hideModal}
          onCancel={hideModal}
        />
      )}
    </>
  );
};
